<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";

export default {
  locales: {
    pt: {
    },
    es: {
    },
  },
  components: {
    Layout,
    VclList,
  },
  data() {
    return {
      loading: true,
      errored: false,

      plan: "all",

      total: 0,
      fields: [
        { key: "avatar", label: "" },
        { key: "plan", label: "Tipo", sortable: true },
        { key: "name", label: "Nome", sortable: true },
        { key: "person_number", label: "CPF/CNPJ" },
        { key: "date", label: "Data", sortable: true },
        { key: "cellphone", label: "Celular" },
        { key: "apvs", label: "Última Adesão", sortable: true },
      ],
      items: null,

      sortBy: "name",
      sortDesc: false,
      currentPage: "1",
      perPage: "25",
      periodMonth: new Date(),
      filterBy: "",
      filterOn: [
        "name",
      ],
      filterOptions: {
        name: "Nome",
        date: "Data",
        level: "Nível",
      },

      totalUsers: 0,
      NameFilter: "",
    };
  },
  methods: {
    getList() {
      this.loading = true;
      this.errored = false;
      this.total = 0;
      this.items = null;
      this.totalUsers = 0;
      this.currentPage = 1;

      api
        .get("network/sponsored?plan=" + this.plan +
          "&searchname=" + this.NameFilter)
        .then((response) => {
          if (response.data.status == 'success') {
            this.items = response.data.list;
            this.totalUsers = response.data.total;
          }
        })
        .catch((error) => {
          this.errored = error;
        })
        .finally(() => {
          this.loading = false;
          if (this.body == "" || this.body == null) {
            this.empty = true;
          }
        });
    }
  },
  mounted() {
  this.getList();
  },
  watch: {
    'plan': function () {
      this.getList();
    },
    'NameFilter': function () {
      this.getList();
    },
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Diretos</h3>
        <p></p>
      </div>
    </div>

    <div class="filter-bar d-flex mb-4">
      <div class="totals">
        <h6 class="m-0 text-secondary">total de diretos</h6>
        <div>{{ this.totalUsers | points }}</div>
      </div>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">Tipo</h6>
              <div v-if="plan == 'all'">Todos</div>
              <div v-else-if="plan == 'regional'">Regionais</div>
              <div v-else-if="plan == 'consultor'">Consultores</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="plan" value="all">Todos</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="plan" value="regional">Regionais</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="plan" value="consultor">Consultores</b-form-radio></b-dropdown-form>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">itens por página</h6>
              <div>{{ perPage }} itens</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="perPage" value="10">10 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="25">25 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="50">50 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="100">100 itens</b-form-radio></b-dropdown-form>
      </b-dropdown>
    </div>
    <div class="filter-bar d-flex mb-4">
      <div class="totals">
        <h6 class="m-0 text-secondary">Filtrar Por Nome</h6>
      </div>
      <input v-model="NameFilter" type="text" class="form-control search" id="nameFilter" aria-label="Nome do consultor ou da Regional" placeholder="Nome do consultor ou da Regional" />
    </div>

    <div class="card">
      <div class="card-body min-vh-25">
        <div class="error text-center min-vh-25" v-if="errored">
          Pedimos desculpas, não podemos recuperar informações neste momento. Por favor, tente novamente mais tarde.
        </div>
        <vcl-list v-else-if="loading" class="col-md-6"></vcl-list>
        <div v-else-if="items && items.length == 0" class="empty text-center min-vh-25 d-flex align-items-center justify-content-center">
          <strong>Nenhum registro encontrado.</strong>
        </div>
        <div v-else class="table-responsive">
          <div class="d-none" style="gap: 15px;">
            <div>
              <b-form-select v-model="filterOn" :options="filterOptions"></b-form-select>
            </div>
            <div class="flex-fill">
              <b-input v-model="filterBy" placeholder="Busca" class="mb-4"></b-input>
            </div>
          </div>
          <b-table stacked="md" :items="items" :fields="fields" class="table-nowrap table-style table-hover min-vh-25" head-variant="light" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :current-page="currentPage" :per-page="perPage" :filter="filterBy" :filter-included-fields="filterOn" responsive>
            <template #cell(avatar)="row">
              <img v-if="row.item.avatar" class="rounded-circle header-profile-user" :src="row.item.avatar" alt="" style="width: 40px; height: 40px" />
              <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=27416E&color=fff&name=' + row.item.name" alt="" style="width: 40px; height: 40px" />
            </template>
            <template #cell(package)="row">
              <span class="badge badge-soft-dark font-size-12">{{
                row.item.package
                }}</span>
            </template>
            <template #cell(apvs)="row">
              {{ row.item.apvs.date_last_contract }}
            </template>
            <template #cell(graduation)="row">
              <img v-if="row.item.graduation.image" class="rounded-circle header-profile-user" :src="require('@/assets/images/graduations/' + row.item.graduation.image)
                " alt="" style="width: 40px; height: 40px" />
              <img v-else class="rounded-circle header-profile-user" src="@/assets/images/logo-icon.png" alt="" style="width: 40px; height: 40px" />
              <span class="badge font-size-12">{{ row.item.graduation.name }}</span>
            </template>
            <template #cell(status)="row">
              <span v-if="row.item.status === 'Pending'" class="badge badge-soft-warning p-2 font-size-12 font-weight-bold text-uppercase">{{ row.item.status }}</span>
              <span v-else-if="row.item.status === 'Approved'" class="badge badge-soft-success p-2 font-size-12 font-weight-bold text-uppercase">{{ row.item.status }}</span>
            </template>
          </b-table>
          <b-pagination v-if="totalUsers > 0" class="m-0 mt-3" v-model="currentPage" :total-rows="totalUsers" :per-page="perPage" pills align="center"></b-pagination>
        </div>
      </div>
    </div>
  </Layout>
</template>
